import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { combineLatest, Observable, zip } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { map } from 'rxjs/operators';

export abstract class FilterService<T> {

    private registeredFilters: FilterAssistQuery<T>[] = [];

    public registerFilters(filter: FilterAssistQuery<T>): void {
        this.registeredFilters.push(filter);
    }

    public autocompleteTerms(terms: string): Observable<FilterAssist[]> {
        return combineLatest(this.registeredFilters.map((filter) => filter.match(terms))).pipe(
            map((results) => results.flat()),
            map((results) => results.sort((a, b) => {
                return a.score - b.score;
            }))
        );
    }

    public activeAssists(query: T): Observable<FilterAssist[]> {
        return zip(...this.registeredFilters.map((filter) => filter.active(query))).pipe(
            map((results) => results.flat())
        );
    }

    public applyAssist(query: T, id: string, terms: string): T {
        const newQuery = { ...query };
        for (const filter of this.registeredFilters) {
            if (filter.ids().indexOf(id) >= 0) {
                filter.apply(id, terms, newQuery);
            }
        }
        return newQuery;
    }

    public removeAssist(query: T, id: string): T {
        const newQuery = { ...query };
        for (const filter of this.registeredFilters) {
            if (filter.ids().indexOf(id) >= 0) {
                filter.unapply(id, newQuery);
            }
        }
        return newQuery;
    }

}
